import { DataAdapter } from "@/DataAdapter/DataAdapter"
import { GetTagValueRequest, SavedLiveTagRequest, SavedLiveTagResponse } from "@/model/SATOSLive/Settings/SavedTagValue"
import { LiveSettingsRequest } from "@/model/SATOSLive/Settings/SettingsRequest"
import { LiveSettingsResponse } from "@/model/SATOSLive/Settings/SettingsResponse"

export const fetchLiveSettings = () : Promise<LiveSettingsResponse> => {
    return DataAdapter.Get<LiveSettingsResponse>({
        endpoint: 'satoslive/settings'
    })
}

export const fetchSavedTagValueByTag = (request: GetTagValueRequest) : Promise<SavedLiveTagResponse> => {
    return DataAdapter.Get<SavedLiveTagResponse>({
        endpoint: `satoslive/savedTagValue/`,
        queryParams: `${request.ProcedureId}/${request.SchemeId}/${request.StepId}/${request.Tag}`
    })
}

export const postLiveSettings = (request: LiveSettingsRequest) : Promise<LiveSettingsResponse> => {
    return DataAdapter.Post<LiveSettingsResponse>(
        "satoslive/settings",
        request
    )
}

export const saveLiveTagValue = (request: SavedLiveTagRequest) : Promise<SavedLiveTagResponse> => {
    return DataAdapter.Post<SavedLiveTagResponse>(
        "satoslive/saveLiveTagValue",
        request
    )
}